import { useLocation } from "react-router-dom";
import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from "antd";

import { getNotes, saveNote, getNoteLogs } from 'store/eligibility/pac/actions';
import { get } from 'store/eligibility/noteDocs/actions';
import { downloadMemberDocument, CategoryModel } from "store/eligibility/documents/actions";
import { uploadFilestoAuth } from 'store/authorization/files/actions';
import { getCategory } from "store/eligibility/documents/actions";

import PostAcuteCareNotesDetail from "components/Eligibility/MemberEligibilityDetailTables/PostAcuteCareNotesTab/PostAcuteCareNotesDetail";

import './index.scss';

interface CareNoteDetailPageProps {
  getNoteLogs(noteId: number): any;
  get(noteId: number): any;
  downloadMemberDocument(memberFilePath: string, memberFileName: string, membMpiNo: string): any,
  uploadFilestoAuth(options: Object): any,
  saveNote(note: Object): any
  getCategory(model: CategoryModel): any,
  isFetchingNoteLogs: boolean,
  isUploading: boolean
}

const { Title } = Typography;

const CareNoteDetailPage = (props: CareNoteDetailPageProps) => {
  const location: any = useLocation();

  return (
    <>
      <div className="care-note-detail-page">
        <div className="header-title">
          <Title level={4} className="ml-3">Member Post Acute Care Note</Title>
        </div>

        <PostAcuteCareNotesDetail
          getNoteLogs={props.getNoteLogs}
          get={props.get}
          downloadMemberDocument={props.downloadMemberDocument}
          uploadFilestoAuth={props.uploadFilestoAuth}
          getCategory={props.getCategory}
          saveNote={props.saveNote}
          eligibilityMemberInfo={location.state.eligibilityMemberInfo}
          primaryCareProvider={location.state.primaryCareProvider}
          pacNote={location.state.pacNote}
          noteId={location.state.noteId}
          isUploading={props.isUploading}
          isFetchingNoteLogs={props.isFetchingNoteLogs}
        />
      </div>
    </>
  );
}

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingPlanLogs: store.rootReducer.eligibilityPAC.isFetchingPlanLogs, //Clinical Plan Notes log table
  isUploading: store.rootReducer.authFiles.isUploading, //upload file
  isFetchingNoteLogs: store.rootReducer.eligibilityPAC.isFetchingNoteLogs //fetch note logs
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getNotes,
    saveNote,
    getNoteLogs,
    get,
    uploadFilestoAuth,
    downloadMemberDocument,
    getCategory
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(CareNoteDetailPage);
